import styled from "styled-components";

import { CouponDetailStyledProps as Props } from "./CouponDetail.types";
import CONSTANTS from "config/constants";

const { mobile } = CONSTANTS.BREAKPOINTS;

const CouponDetailStyled = styled.div<Props>`
  display: flex;
  margin-bottom: 1.6rem;
  flex-direction: column;
  flex: 1;

  .CouponDetail {
    &__container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 10.4rem;
      border: none;

      border-radius: 0.8rem;
      padding: 1.6rem;
      background-color: var(--palette-black-s2-l21);

      @media (max-width: ${mobile}px) {
        padding: 0.8rem;
      }
    }

    &__left {
      display: flex;
      text-align: left;
      align-items: center;

      &__icon {
        min-width: 2.4rem;
        min-height: 2.4rem;
        border: 0.1rem solid var(--palette-gray-s0-l40);
        border-radius: 10rem;
        margin-right: 1.2rem;
      }

      &__label {
        &__title {
          font-size: 1.6rem;
          font-weight: 700;
          font-family: inherit;
          color: var(--palette-white);
        }

        &__description {
          font-size: 1.4rem;
          color: var(--palette-gray-s0-l73);
          font-weight: 400;
          margin-top: 0.4rem;
        }

        &__expiration-date {
          font-size: 1.2rem;
          font-weight: 400;
          color: var(--palette-gray-s0-l73);
          padding-top: 0.8rem;
        }
      }
    }

    &__radio {
      width: 2.4rem;
      height: 2.4rem;
      border: 0.1rem solid var(--palette-gray-s0-l80);
      border-radius: 10rem;
      margin-right: 1.2rem;

      &--active {
        border: 0.7rem solid var(--palette-primary);
      }
    }

    &__right {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__remove {
      padding: 0;

      svg {
        path {
          fill: var(--palette-white);
        }
      }
    }

    &__remove-error {
      font-size: 1.2rem;
      color: var(--palette-red-s60-l60);
      padding-top: 0.4rem;
    }
  }
`;

export default CouponDetailStyled;
